jQuery(document).ready(function($) {

	/* About Gallery - BEGIN */
		var aboutGallery = $(".about-gallery .listing");

		aboutGallery.addClass("owl-carousel").owlCarousel({
			items: 1,
			margin: 0,
			dots: false,
			loop: true,
			autoplay: false
		});

		$("body").on('click', '#gallery-prev', function(event) {
			aboutGallery.trigger('prev.owl.carousel');
		});

		$("body").on('click', '#gallery-next', function(event) {
			aboutGallery.trigger('next.owl.carousel');
		});
	/* Memorial Videos - END */

});